import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { RecommendationsAdvertisement } from '../components/recommendationsAdvertisement/RecommendationsAdvertisement';
import { BlockWidths } from '../components/pageLayouts/BlockTypes.utils';
import { AdditionalStyleSheet } from '../components.utils';
import { createBlockStyle } from './blockMutualStyle';

interface OutbrainRecommendationsProps {
  outbrainWidgetID: string;
  pageLiveUrl: string;
  experiment?: string;
  defaultBlocksWidths: BlockWidths;
  additionalStyle?: AdditionalStyleSheet;
}

const getDefaultBlocksWidthsStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
    },
  });
};

export const OutbrainRecommendations: React.FunctionComponent<OutbrainRecommendationsProps> = props => {
  const { outbrainWidgetID, pageLiveUrl, experiment, defaultBlocksWidths, additionalStyle } = props;
  const blockStyle = getDefaultBlocksWidthsStyle(defaultBlocksWidths);

  return (
    <div className={css(blockStyle.style, additionalStyle?.style)}>
      <RecommendationsAdvertisement
        experiment={experiment}
        outbrainWidgetID={outbrainWidgetID}
        pageLiveUrl={pageLiveUrl}
        disableDefaultStyle
      />
    </div>
  );
};
